import { render, staticRenderFns } from "./GroupsDropDown.vue?vue&type=template&id=570c0b2d&"
import script from "./GroupsDropDown.vue?vue&type=script&lang=js&"
export * from "./GroupsDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports